export default __webpack_public_path__ + "static/media/shield-icon.de8a7cf4.svg";